import Vue from 'vue'
import { repository, datatableCollection } from '@/packages/vue-repository'

const endpoint = 'scheduled_exports'

export default ({ api }) => {
  return new Vue({
    mixins: [
      repository({ api, endpoint }),
      datatableCollection({ api, endpoint })
    ]
  })
}